import React, { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Button from '../../../components/button/button';
import FormInput from '../../../components/formInput/FormInput';
import PDFViewer, { PdfMenu } from '../../../components/pdfViewer/PDFViewer';
import useReportGenerator from '../../../hooks/useReportGenerator';
import { useReportStore } from '../../../store/ReportStore';
import { ReportHandler } from '../Report';
import styles from '../Report.module.scss';

interface StatementForm {
  companyName: string;
}

const StatementReportSection: FC<ReportHandler> = ({ validChanged }) => {
  const {
    statementReportCompany,
    setStatementReportCompany,
    riskManagementReportPDF,
    setRiskManagementReportPDF,
  } = useReportStore();
  const { generateReportHook } = useReportGenerator('riskManagementReport');
  const formMethods = useForm<StatementForm>({
    defaultValues: { companyName: statementReportCompany },
  });
  const {
    getValues,
    formState: { isValid },
  } = formMethods;

  useEffect(() => {
    validChanged(riskManagementReportPDF != null);
  }, [riskManagementReportPDF]);

  const [menus] = useState<PdfMenu[]>([
    {
      label: 'Change company name',
      callback: () => setRiskManagementReportPDF(null),
    },
  ]);

  const generateReport = async () => {
    if (!isValid) return;

    setStatementReportCompany(getValues('companyName'));
    generateReportHook(getValues('companyName'));
  };

  return (
    <div className={styles.statementReportMain}>
      {riskManagementReportPDF ? (
        <PDFViewer menus={menus} type="riskManagementReport"></PDFViewer>
      ) : (
        <>
          <FormProvider {...formMethods}>
            <FormInput
              id="companyName"
              label="Company name"
              placeholder="Enter company name"
              required
            />
          </FormProvider>

          <Button
            className={styles.generateStatementButton}
            disabled={!isValid}
            onClick={generateReport}
          >
            Generate Statement Report
          </Button>
        </>
      )}
    </div>
  );
};

export default StatementReportSection;
